import React, { useEffect, useState } from 'react';
import { Typography, Grid } from '@mui/material';
import { AlertError, CallBox, CallButton, CallDetails, CallHeader, CallStateError } from './call-styles';
import { Close, ErrorOutline, Phone } from '@mui/icons-material';
import CallWarningActions from './call-warning-actions';
import { formatUSPhoneNumber } from '../../utils/formatter';
import { useLwp } from '../../hooks/use-lwp';

export default function CallErrorNoMicrophone() {
  const {
    hangupCall,
    phoneState: { phoneNumber, contactName, isErrorIgnored }
  } = useLwp();

  if(isErrorIgnored) return null;

  return (
    <CallBox data-testid="call-error-not-created">
      <CallHeader>
        <Grid container>
          <Grid item xs={6} zeroMinWidth>
            <CallStateError>ERROR</CallStateError>
            <Typography variant="h6" noWrap>
              {contactName ? contactName : ''}
            </Typography>
            <Typography variant="body2">{formatUSPhoneNumber(phoneNumber)}</Typography>
            <Typography variant="body2">--:--</Typography>
          </Grid>
          <Grid item xs={6} style={{ textAlign: 'right' }}>
            <CallButton disabled sx={{ backgroundColor: 'rgb(77, 206, 160)', '&:hover': { backgroundColor: 'rgb(77, 206, 160)' } }}>
              <Phone />
            </CallButton>
            <CallButton onClick={hangupCall}>
              <Close sx={{ fontSize: 32 }} />
            </CallButton>
          </Grid>
        </Grid>
        <AlertError icon={<ErrorOutline style={{ fontSize: 22, color: '#E31B0C' }} />} severity="error">
          Your microphone isn't working. Switch to a different device or try reconnecting this one.
        </AlertError>
      </CallHeader>
      <CallDetails>
        <CallWarningActions phoneNumber={phoneNumber} />
      </CallDetails>
    </CallBox>
  );
}
